import { render, staticRenderFns } from "./officeSuppliesPurchaseHis.vue?vue&type=template&id=9192e048&scoped=true"
import script from "./officeSuppliesPurchaseHis.vue?vue&type=script&lang=js"
export * from "./officeSuppliesPurchaseHis.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesPurchaseHis.vue?vue&type=style&index=0&id=9192e048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9192e048",
  null
  
)

export default component.exports